import React, { useEffect, useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'
import routes from '../routes'
import { Footer } from '../components'
import Header from '../components/layout/header/Header'
import Sidebar from '../components/layout/sideNavigationMenu/sideNavigationMenu'
import './authorizedContent.scss'

const { Content } = Layout

export default function AuthorizedContent() {
  const [collapsed, setCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Check if we're on mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
      // Optionally auto-collapse on mobile
      if (window.innerWidth <= 768) {
        setCollapsed(true)
      }
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const toggleSidebar = () => {
    setCollapsed(!collapsed)
  }

  // Determine inner layout class based on state
  const getInnerLayoutClass = () => {
    if (isMobile) return 'authorized-layout__inner-layout--mobile'
    return collapsed 
      ? 'authorized-layout__inner-layout--collapsed' 
      : 'authorized-layout__inner-layout--expanded'
  }

  return (
    <Layout className="authorized-layout">
      {/* Fixed header that stays on top */}
      <div className="authorized-layout__header">
        <Header 
          menuToggleEnabled={true}
          toggleMenu={toggleSidebar}
          collapsed={collapsed}
        />
      </div>
      
      {/* Backdrop for mobile - closes sidebar when clicking outside */}
      {isMobile && !collapsed && (
        <div 
          className="authorized-layout__backdrop"
          onClick={toggleSidebar}
        />
      )}
      
      <Layout className="authorized-layout__main">
        {/* Sidebar that starts below the header */}
        <Sidebar collapsed={collapsed} topOffset={64} />
        
        <Layout className={`authorized-layout__inner-layout ${getInnerLayoutClass()}`}>
          <Content className="authorized-layout__content">
            <Routes>
              {routes.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
              <Route path="*" element={<Navigate to="/accessDenied" replace />} />
            </Routes>
          </Content>
          <Footer className="authorized-layout__footer" />
        </Layout>
      </Layout>
    </Layout>
  )
}